import { useState, createContext, useContext, useEffect } from "react";

type LoaderProviderProps = {
  children: React.ReactNode;
};

type AuthContextType = {
  loading: boolean;
};

declare global {
  interface Window {
    startLoading(): void;
    stopLoading(): void;
  }
}

const LoaderContext = createContext<AuthContextType | null>(null);

export const LoaderProvider = ({ children }: LoaderProviderProps) => {
  const [loading, setLoading] = useState(false);
  const startLoading = () => {
    setLoading(true);
  };
  const stopLoading = () => {
    setLoading(false);
  };

  useEffect(() => {
    window.startLoading = startLoading;
    window.stopLoading = stopLoading;
  }, []);

  return (
    <LoaderContext.Provider value={{ loading }}>
      {children}
    </LoaderContext.Provider>
  );
};

export const useLoader = () => {
  return useContext(LoaderContext);
};
